import { render, staticRenderFns } from "./DigitalSkills.vue?vue&type=template&id=4dfc9d90&scoped=true"
import script from "./DigitalSkills.vue?vue&type=script&lang=js"
export * from "./DigitalSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc9d90",
  null
  
)

export default component.exports